import rangeModeRecommendations from '@/consts/experienceScore/rangeModeRecommendations';
import type {InferenceRawItem} from '@/types/inference';

const inferenceMock: InferenceRawItem = {
    inferenceName: 'TipsTricks',
    inferredOn: '2026-07-16T14:32:24.000Z',
    result: {
        Calibration: {
            cycle_count: 125,
            n_records_received: 58,
            n_sticks_identified: 10,
            min_n_experiences_required: 10,
            status: 'Optimal',
            first_usage_time: '2026-04-10 08:15:00',
            last_usage_time: '2026-04-20 21:40:00',
        },
        TipsAndTricks: {
            EG002: {
                require_engagement: true,
                status: 'Sub Optimal',
                current_behavior: 15.2,
                threshold: 20,
                history: {
                    trend: 'Stable',
                    communication: 'TC8',
                },
            },
            EG004: {
                require_engagement: true,
                status: 'Sub Optimal',
                current_behavior: 3,
                threshold: 2,
                history: {
                    trend: 'Down',
                    communication: 'TC15',
                },
            },
            short_session: {
                require_engagement: true,
                status: 'Sub Optimal',
                current_behavior: 308.2,
                threshold: 232.64,
                history: {
                    trend: '',
                    communication: '',
                },
            },
            frequent_limitation: {
                require_engagement: true,
                status: 'Sub Optimal',
                current_behavior: 100,
                threshold: 80.56,
                history: {
                    trend: '',
                    communication: '',
                },
            },
            device_overheating: {
                require_engagement: true,
                status: 'Sub Optimal',
                current_behavior: 75,
                threshold: 10,
                history: {
                    trend: '',
                    communication: '',
                },
            },
            // TODO: not returned by the backend yet
            times_tuned: {
                require_engagement: false,
                status: 'Optimal',
                current_behavior: 5,
                threshold: 0,
                history: {
                    trend: '',
                    communication: '',
                },
            },
            // TODO: not returned by the backend yet
            average_puffs: {
                require_engagement: false,
                status: 'Optimal',
                current_behavior: 11.2,
                threshold: 0,
                history: {
                    trend: '',
                    communication: '',
                },
            },
            // TODO: not returned by the backend yet
            average_duration: {
                require_engagement: false,
                status: 'Optimal',
                current_behavior: 295.8,
                threshold: 0,
                history: {
                    trend: '',
                    communication: '',
                },
            },
        },
        Insights: {
            sku: {
                perc_terea_stick: 76,
                perc_sentia_delia_stick: 10,
                perc_axia_stick: 3,
                perc_levia_stick: 10,
                perc_unknown_stick: 0,
            },
            tunability: {
                perc_tunability: 60,
                perc_optimal_profile: 99,
                perc_intense_profile: 88,
                perc_original_profile: 14,
                perc_boost_profile: 0,
                perc_extend_profile: 0,
                perc_sticks_with_tuning_enabled: 52,
            },
            range_profile: {
                recommendation: rangeModeRecommendations.ENABLE,
                perc_2_back_to_back: 10,
                perc_3_back_to_back: 50,
                perc_4_back_to_back: 30,
                perc_5_back_to_back: 10,
                history: {
                    trend: '',
                    communication: '',
                },
            },
        },
        LastExperiences: {
            EG002: {
                '0': {require_engagement: true, heating_profile: 'optimal', threshold: 20},
                '1': {require_engagement: false, heating_profile: 'optimal', threshold: 20},
                '2': {require_engagement: false, heating_profile: 'optimal', threshold: 20},
                '3': {require_engagement: false, heating_profile: 'intense', threshold: 20},
                '4': {require_engagement: false, heating_profile: 'optimal', threshold: 20},
            },
            EG004: {
                '0': {require_engagement: true},
                '1': {require_engagement: true},
                '2': {require_engagement: true},
                '3': {require_engagement: true},
                '4': {require_engagement: true},
            },
            short_session: {
                '0': {require_engagement: false},
                '1': {require_engagement: false},
                '2': {require_engagement: false},
                '3': {require_engagement: false},
                '4': {require_engagement: false},
            },
            frequent_limitation: {
                '0': {require_engagement: true},
                '1': {require_engagement: true},
                '2': {require_engagement: true},
                '3': {require_engagement: true},
                '4': {require_engagement: true},
            },
            device_overheating: {
                '0': {require_engagement: true},
                '1': {require_engagement: true},
                '2': {require_engagement: false},
                '3': {require_engagement: false},
                '4': {require_engagement: true},
            },
        },
        Metadata: {
            version: '0.4.0',
        },
        experience_score: {
            score: 2,
            max_score: 5,
            status: 'Not Ideal',
            // Warnings win: empty sub_optimal to see the tips stack.
            tips_to_consider: {
                sub_optimal: ['EG002', 'short_session', 'frequent_limitation'],
                optimal: ['EG002', 'short_session', 'frequent_limitation', 'tunability', 'range_profile'],
            },
            history: {
                trend: 'Stable',
                communication: 'TC28',
            },
        },
    },
};

export const getInferenceMockResponse = () => {
    const item = structuredClone(inferenceMock);

    item.inferredOn = new Date().toISOString();

    return {data: [item]};
};

export default inferenceMock;
